import { Input, Modal } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'
import {
  RECYCLE_BIN_FOLDER_TYPE,
  UGC_FOLDER_TYPE,
  VIRTUAL_FOLDER_TYPE,
} from '../../dux/constants/folder'
import { buildPath, validatePrivilege } from '../../dux/modules/utils'
import TreeNode from '../sidebar/TreeNode'

import '../styles/Modal.css'

class AddFolderModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeFolder: this.props.folders.activeFolder,
      openFolderKeys: this.props.appState.openFolderKeys,
    }
  }

  save = () => {
    const { user, folders, modalProps, modalActions, folderActions } =
      this.props

    //Make sure name is populated
    if (folders.newFolderName.length === 0)
      folderActions.setNewFolderName('New Folder')

    //Set Active folder
    folderActions.activeFolder(this.state.activeFolder)

    //If this is a web folder type, then we will short circuit the permissions modal
    //and just save the folder
    const folderType =
      modalProps && modalProps.endpointType === 'web' ? 'webfolder' : null
    const skipPermissionsModal = folderType === 'webfolder'

    if (skipPermissionsModal) {
      const folderName =
        folders.newFolderName.length > 0 ? folders.newFolderName : 'New Folder'

      const parentFolder = folders.byId[folders.activeFolder]

      const folderPath = buildPath(folders.activeFolder, folders.byId)

      // Inherit Web Endpoint folder content roles from parent folder.
      const contentRoles = parentFolder.contentRoles

      folderActions.addFolder(
        folderName,
        parentFolder,
        user.id,
        user.client,
        contentRoles,
        folderPath,
        folders.byId,
        folderType,
      )
    } else {
      modalActions.openModal('FolderPermissionsModal', { newFolder: true })
    }
  }

  cancel = () => {
    this.props.modalActions.closeModal()
    this.props.folderActions.setNewFolderName('')
  }

  nodeIsActive = (id) => this.state.activeFolder === id

  nodeIsOpen = (id) => this.state.openFolderKeys.indexOf(id) > -1

  nodeIsDraggable = () => {
    return false
  }

  onNodeClick = (id) => {
    if (this.state.activeFolder !== id) {
      this.setState({ activeFolder: id })
    }
  }

  toggleFolder = (id) => {
    if (!this.nodeIsDisabled(id)) {
      if (this.state.openFolderKeys.indexOf(id) < 0) {
        this.setState({
          openFolderKeys: this.state.openFolderKeys.concat([id]),
        })
      } else {
        this.setState({
          openFolderKeys: this.state.openFolderKeys.filter((key) => key !== id),
        })
      }
    }
  }

  removeOpenFolderKey = (id) => {
    this.setState((prevState) => {
      return {
        openFolderKeys: prevState.openFolderKeys.filter((key) => key !== id),
      }
    })
  }

  nodeLink = () => this.props.location.pathname

  nodeIsDisabled = (id) =>
    !validatePrivilege(
      'addfolder',
      this.props.permissions.privileges,
      this.props.user.email,
      this.props.permissions.groups,
      id,
      this.props.folders.byId,
    )

  setActiveFolder = (id) => {
    this.setState({ activeFolder: id })
  }

  // Not needed for addFolderModal
  allowPublishing = () => false

  // Not needed for addFolderModal
  getPendingCount = () => 0

  render() {
    const { modalProps } = this.props
    const skipPermissionsModal =
      modalProps && modalProps.endpointType && modalProps.endpointType === 'web'

    return (
      <Modal
        title="New Folder"
        okText={skipPermissionsModal ? 'SAVE' : 'NEXT'}
        onOk={this.save}
        cancelText="Cancel"
        onCancel={this.cancel}
        open={this.props.modal.modalOpen}
        confirmLoading={this.props.appState.asyncPending}
        maskClosable={false}
      >
        <Input
          className="modal__input"
          type="text"
          value={this.props.folders.newFolderName}
          onChange={(e) =>
            this.props.folderActions.setNewFolderName(e.target.value)
          }
          onPressEnter={this.save}
          placeholder="New Folder"
          autoFocus
        />
        <div className="modal__text">Select a destination:</div>
        <div className="modal-tree-container">
          {this.props.modalProps.treeRoot
            .filter(
              (folder) =>
                ![
                  RECYCLE_BIN_FOLDER_TYPE,
                  UGC_FOLDER_TYPE,
                  VIRTUAL_FOLDER_TYPE,
                ].includes(this.props.folders.byId[folder].type),
            )
            .map((folderid) => {
              return (
                <TreeNode
                  key={folderid}
                  {...this.props}
                  activeFolder={this.state.activeFolder}
                  openFolderKeys={this.state.openFolderKeys}
                  removeOpenFolderKey={this.removeOpenFolderKey}
                  node={this.props.folders.byId[folderid]}
                  nodeLink={this.nodeLink}
                  isFolder
                  nodeIsActive={this.nodeIsActive}
                  nodeIsOpen={this.nodeIsOpen}
                  isRoot={!!this.props.folders.byId[folderid].parentId}
                  nodeIsDraggable={this.nodeIsDraggable}
                  rightClickDisabled={true}
                  onToggle={this.toggleFolder}
                  onNodeClick={this.onNodeClick}
                  nodeIsDisabled={this.nodeIsDisabled}
                  setActiveFolder={this.setActiveFolder}
                  allowPublishing={this.allowPublishing}
                  badges={[]}
                  getBadgeCount={null}
                  style={{
                    treenodeText: {
                      color: 'rgba(0,0,0,.65)',
                    },
                    treenodeIcon: {
                      color: 'rgba(0,0,0,.65)',
                    },
                  }}
                />
              )
            })}
        </div>
      </Modal>
    )
  }
}

/*
 *  modal/modalActions and folder/folderActions are the redux state and actions
 */
AddFolderModal.propTypes = {
  modal: PropTypes.object,
  modalProps: PropTypes.object,
  modalActions: PropTypes.object,
  appState: PropTypes.object,
  folders: PropTypes.object,
  folderActions: PropTypes.object,
  user: PropTypes.object,
}

export default AddFolderModal
